import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function DocsMagento() {
  return (
    <IntegrationDocTemplate
      title="Magento / Adobe Commerce"
      category="Platform"
      status="beta"
      summary="Magento 2.x / Adobe Commerce REST + GraphQL APIs. OAuth or admin token auth. Best for mid-market merchants with custom workflows. Self-hosted + Adobe Commerce Cloud supported."
      prerequisites={[
        'Magento 2.3+ or Adobe Commerce 2.4+.',
        'Admin user with API access (Stores → Configuration → Services → OAuth or token-based).',
        'API endpoint reachable: typically https://{store}/rest/V1.',
      ]}
      connectSteps={[
        'Text us "Magento" with your phone number.',
        'Generate an admin integration token in Magento Admin → System → Integrations.',
        'Paste the token + store URL.',
        'First sync: catalog, orders, customers, inventory (with chunking for stores >25K SKUs).',
      ]}
      syncedData={[
        { type: 'Catalog', detail: 'Configurable + simple products, attributes, attribute sets, categories' },
        { type: 'Orders', detail: 'Order list + items + invoices + shipments + credit memos' },
        { type: 'Inventory (MSI)', detail: 'Multi-Source Inventory: stocks, sources, salable_quantity per source' },
        { type: 'Customers', detail: 'Customer accounts + addresses + groups' },
      ]}
      agents={[
        { id: 'head_ecommerce', name: 'head_ecommerce', role: 'Channel routing director' },
        { id: 'cross_channel_inventory_agent', name: 'cross_channel_inventory_agent', role: 'Reserves Magento MSI inventory across channels' },
      ]}
      troubleshooting={[
        { question: 'GraphQL queries slow', answer: 'Magento GraphQL has high baseline latency. Our adapter prefers REST for sync, GraphQL only for complex catalog queries.' },
        { question: 'Admin token revoked', answer: 'Magento admin sessions expire after admin password change. Re-issue integration token in System → Integrations.' },
      ]}
      supportLink="/contact"
    />
  );
}
